import {
  Button,
  Col,
  DatePicker,
  Modal,
  Row,
  Select,
  Space,
  Empty,
} from "antd";
import React, { Component } from "react";
import withRouter from "../withRouter";
import Cookies from "js-cookie";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";
import TemperatureDashboardStore from "../store/TemperatureDashboardStore";
import { decode as base64_decode } from "base-64";
import dayjs from "dayjs";
import CompanyAutocomplete from "./CompanyAutocomplete";
import {
  Legend,
  Line,
  LineChart,
  ResponsiveContainer,
  XAxis,
  YAxis,
  Tooltip,
} from "recharts";
import { RightCircleOutlined } from "@ant-design/icons";
class GatewayDashboard extends Component {
  constructor(props, context) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
    this.temperatureDashboardStore = new TemperatureDashboardStore(this);

    this.state = {
      activeSensorCount: 0,
      offset: 0,
      limit: 50,
      update: 0,
      showSensorTable: false,
      type: 0,
      loadData: 0,
      vehiclesArray: [],
      vehicleId: "",
      fromDate: dayjs().format("YYYY-MM-DD 00:00:00"),
      toDate: dayjs().format("YYYY-MM-DD 23:59:00"),
      showGatewaySensors: false,
      gatewayList: [],
      selectedGateways:
        JSON.parse(base64_decode(Cookies.get("data"))).isadmin == 1 ? [-1] : [],
      sensorsList: [],
      selectedSensors: [],
      sensorDetails: [],
      showSensorGraph: false,
      sensorFromDate: dayjs().format("YYYY-MM-DD 00:00:00"),
      sensorToDate: dayjs().format("YYYY-MM-DD 23:59:00"),
      sensorId: -1,
      sensorVehicleId: -1,
      sensorGraphArray: [],
      sensorVehicleNo: "",
    };
  }

  async componentDidMount() {
    if (JSON.parse(base64_decode(Cookies.get("data"))).isadmin == 1) {
      await this.setState({
        companyId: JSON.parse(base64_decode(Cookies.get("data"))).userCompanyId,
      });
      await this.getServiceData(this.state.companyId);
      const sensorDetails =
        await this.temperatureDashboardStore.loadSensorDetailsByIds(
          this.state.companyId,
          this.state.selectedGateways
        );
      this.setState({ sensorDetails });

      const sensors =
        await this.temperatureDashboardStore.loadSensorsByGateways(
          this.state.companyId,
          this.state.selectedGateways
        );
      this.setState({ sensorsList: sensors });
    }
    await this.setState({ update: 1 });
  }

  showSensorsGraph = async () => {
    const sensorGraphArray =
      await this.temperatureDashboardStore.loadSensorGraphData({
        companyId: this.state.companyId,
        vehicleId: this.state.sensorVehicleId,
        fromDate: this.state.sensorFromDate,
        toDate: this.state.sensorToDate,
        sensorId: this.state.sensorId,
      });

    this.setState({ sensorGraphArray: sensorGraphArray });
    await this.setState({ update: 1 });
  };

  async handleChange(comp) {
    await this.setState({ companyId: comp?.value });
    await this.getServiceData(this.state.companyId);
  }
  getServiceData = async (companyId) => {
    await this.temperatureDashboardStore.loadSensorTableData({
      companyId: companyId,
      userId: JSON.parse(base64_decode(Cookies.get("data"))).userId,
      isadmin: JSON.parse(base64_decode(Cookies.get("data"))).isadmin,
      isSensorTab: this.state.isSensorTab,
    });

    const gateways = await this.temperatureDashboardStore.loadGateways({
      companyId: companyId,
      userId: JSON.parse(base64_decode(Cookies.get("data"))).userId,
      isadmin: JSON.parse(base64_decode(Cookies.get("data"))).isadmin,
    });
    this.setState({ gatewayList: gateways });
    await this.setState({
      activeSensorCount:
        this.temperatureDashboardStore?.sensorDataArray?.length,
    });
  };
  render() {
    return (
      <div className="listHeader">
        <Row className="listInputRow">
          <Col span={16}>
            <Space>
              <CompanyAutocomplete
                className="searchInput"
                onChange={this.handleChange}
                allowClear={true}
                style={{ width: 175 }}
                status={this.state.Notcompany ? "error" : false}
              />
              <Select
                className="searchInput"
                mode="multiple"
                style={{ width: 200 }}
                value={this.state.selectedGateways}
                placeholder={this.context.translate("_VEHICLE_NO_")}
                getPopupContainer={(triggerNode) => triggerNode.parentNode}
                onChange={async (selectedGateways) => {
                  this.setState({ selectedGateways });
                  if (!selectedGateways || selectedGateways.length === 0) {
                    this.setState({ sensorDetails: [] }); // clear existing data if any
                    return;
                  }
                  const CompanyId = this.state.companyId;
                  const sensorDetails =
                    await this.temperatureDashboardStore.loadSensorDetailsByIds(
                      CompanyId,
                      selectedGateways
                    );
                  this.setState({ sensorDetails });
                  const sensors =
                    await this.temperatureDashboardStore.loadSensorsByGateways(
                      CompanyId,
                      selectedGateways
                    );
                  this.setState({ sensorsList: sensors });
                }}
              >
                {this.state.gatewayList.map((gateway) => (
                  <Select.Option
                    key={gateway.deviceId}
                    value={gateway.vehicleId}
                  >
                    {gateway.vehicleNo}
                  </Select.Option>
                ))}
              </Select>
              <Select
                className="searchInput"
                mode="multiple"
                showSearch
                maxTagCount="responsive"
                style={{ width: 250 }}
                onSelect={async (type) => {
                  this.setState({ type: type });
                }}
                optionFilterProp="children"
                filterOption={(input, option) =>
                  option?.children?.toLowerCase().includes(input.toLowerCase())
                }
                placeholder={this.context.translate("_VEHICLENO_SENSORS_")}
                value={this.state.selectedSensors}
                onChange={async (selectedSensors) => {
                  this.setState({ selectedSensors });
                  const CompanyId = this.state.companyId; //JSON.parse(base64_decode(Cookies.get("data"))).userCompanyId
                  const selectedSensorDetails = this.state.sensorsList.filter(
                    (sensor) => selectedSensors.includes(sensor.sensorId)
                  );
                  const vehicleIds = selectedSensorDetails.map(
                    (s) => s.vehicleId
                  );
                  const uniqueVehicleIds = [...new Set(vehicleIds)];
                  console.log(
                    "Selected Sensor-Vehicle Pairs:",
                    uniqueVehicleIds
                  );
                  const sensorDetails =
                    await this.temperatureDashboardStore.loadSensorDetailsByIds(
                      CompanyId,
                      this.state.selectedGateways,
                      selectedSensors
                    );
                  this.setState({ sensorDetails });
                }}
              >
                {this.state.sensorsList.map((sensor, index) => (
                  <Select.Option value={sensor.sensorId}>
                    {sensor.sensor}
                  </Select.Option>
                ))}
              </Select>
            </Space>
          </Col>
        </Row>
        <div
          style={{
            maxHeight: "83vh",
            background: "#f2f3f7",
            padding: "20px",
            margin: "20px 10px 0px 10px",
            overflowY: "auto",
          }}
        >
          {this.state.sensorDetails.length > 0 ? (
            this.state.sensorDetails.map((gateway, index) => (
              <div key={index} style={{ margin: "10px 0px 15px 0px" }}>
                {/* Gateway Header */}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    color: "#0b1a2dff",
                    fontWeight: "600",
                    fontSize: "16px",
                    marginBottom: "15px",
                  }}
                >
                  <span>
                    Gateway:{" "}
                    <span style={{ color: "#002244", fontWeight: "700" }}>
                      {gateway.gatewayName}
                    </span>
                    &nbsp; {/* space */}
                    Vehicle No:{" "}
                    <span style={{ fontWeight: "700" }}>
                      {gateway.vehicleNo || "N/A"}
                    </span>
                  </span>
                  <span>
                    Battery Voltage: {gateway.batteryVoltage}&nbsp;&nbsp;&nbsp;
                    Power Voltage: {gateway.powerVoltage}
                  </span>
                </div>

                {/* Sensor Cards Grid */}
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns:
                      "repeat(auto-fill, minmax(220px, 1fr))",
                    gap: "15px",
                  }}
                >
                  {gateway.sensors.map((sensor) => (
                    <div
                      key={sensor.id}
                      style={{
                        padding: "3px",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "space-between",
                          background: "#ffffff",
                          borderRadius: "10px",
                          overflow: "hidden",
                          boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
                        }}
                      >
                        {/* Top Blue Bar */}
                        <div
                          style={{
                            background: "#001f3f",
                            color: "#fff",
                            textAlign: "center",
                            padding: "8px 0",
                            fontWeight: 600,
                            fontSize: "14px",
                          }}
                        >
                          Sensor ID:{" "}
                          <span style={{ color: "#FFFFFF" }}>{sensor.id}</span>
                        </div>

                        {/* White Middle Content */}
                        <div style={{ padding: "9px", textAlign: "center" }}>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-around",
                              alignItems: "center",
                              marginBottom: "10px",
                            }}
                          >
                            {/* Temperature */}
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                              }}
                            >
                              <span
                                style={{
                                  fontWeight: 500,
                                  fontSize: "14px",
                                }}
                              >
                                Temperature
                              </span>
                              <span
                                style={{
                                  color: "#00A9A5",
                                  fontSize: "22px",
                                  fontWeight: 700,
                                  lineHeight: "26px",
                                }}
                              >
                                {sensor.temp}
                              </span>
                            </div>

                            {/* Humidity */}
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                              }}
                            >
                              <span
                                style={{
                                  fontWeight: 500,
                                  fontSize: "14px",
                                }}
                              >
                                Humidity
                              </span>
                              <span
                                style={{
                                  color: "#A000C8",
                                  fontSize: "22px",
                                  fontWeight: 700,
                                  lineHeight: "26px",
                                }}
                              >
                                {sensor.humidity}
                              </span>
                            </div>
                          </div>

                          <div
                            style={{
                              fontSize: "13px",
                              color: "#444",
                              lineHeight: "20px",
                            }}
                          >
                            <div>Sensor Battery: {sensor.battery}</div>
                            <div>RSSI: {sensor.rssi}</div>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                maxWidth: "220px", // adjust based on your box width
                              }}
                            >
                              Sensor Time: {sensor.timestamp}
                            </div>
                          </div>
                        </div>

                        <div
                          style={{
                            position: "relative",
                            borderRadius: "10px",
                            padding: "12px",
                            color: "#001f3f",
                          }}
                        >
                          {/* Sensor content here */}
                          <div
                            onClick={async () => {
                              const currentDate = dayjs();

                              await this.setState({
                                sensorFromDate: currentDate
                                  .startOf("day")
                                  .format("YYYY-MM-DD"),
                                sensorToDate: currentDate
                                  .endOf("day")
                                  .format("YYYY-MM-DD"),
                                showSensorGraph: true,
                                sensorId: sensor.id,
                                sensorVehicleId: gateway.vehicleId,
                                sensorVehicleNo: gateway.vehicleNo,
                              });
                              await this.showSensorsGraph();
                            }}
                            style={{
                              position: "absolute",
                              bottom: "2px",
                              right: "5px",
                              fontSize: 24,
                              color: "#001f3f", // ✅ blue arrow
                              cursor: "pointer",
                              transition:
                                "transform 0.2s ease, color 0.2s ease",
                            }}
                            onMouseEnter={(e) =>
                              (e.currentTarget.style.transform = "scale(1.1)")
                            }
                            onMouseLeave={(e) =>
                              (e.currentTarget.style.transform = "scale(1.0)")
                            }
                            title="View Sensor Graph"
                          >
                            <RightCircleOutlined />
                          </div>
                        </div>
                        {/* Bottom Blue Bar */}
                        <div
                          style={{
                            background: "#001f3f",
                            height: "14px",
                            borderRadius: "0 0 10px 10px",
                          }}
                        ></div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ))
          ) : (
            <div
              style={{
                textAlign: "center",
                color: "#888",
                padding: "20px",
                fontSize: "15px",
                height: "75vh",
              }}
            >
              <Empty description={false} />
            </div>
          )}
        </div>
        <Modal
          title={
            <div className="modal-topbar">
              {/* Left side title + info */}
              <div
                style={{ display: "flex", alignItems: "center", gap: "12px" }}
              >
                <h1 style={{ margin: 0 }}>
                  {this.context.translate("_SENSOR_GRAPH_")}
                </h1>

                {/* VehicleNo and Sensor ID beside title */}
                <div
                  style={{
                    fontSize: "14px",
                    color: "#FFFFFF",
                    fontWeight: "600",
                  }}
                >
                  {this.state.sensorVehicleNo && (
                    <>{this.state.sensorVehicleNo}</>
                  )}
                  {this.state.sensorId && (
                    <>
                      &nbsp;|&nbsp;
                      {this.state.sensorId}
                    </>
                  )}
                </div>
              </div>
              <div className="right-align">
                {" "}
                <Button
                  type="primary"
                  onClick={async (pagination) => {
                    this.showSensorsGraph();
                  }}
                >
                  {/* Show */}
                  {this.context.translate("_FLEET_SHOW_BTN_")}
                </Button>
                <i
                  class="modal-close las la-times"
                  onClick={() => {
                    this.setState({ showSensorGraph: false });
                  }}
                ></i>
              </div>
            </div>
          }
          className="black-modal-window"
          open={this.state.showSensorGraph}
          footer={null}
          centered
          width="85%"
          onCancel={() => {
            this.setState({ showSensorGraph: false });
          }}
          bodyStyle={{ maxHeight: "67vh", overflowY: "auto" }}
        >
          <div className="temp-report-container sensor-graph-modal">
            <div className="form-row">
              <DatePicker
                className="sensors-field"
                value={
                  this.state.sensorFromDate
                    ? dayjs(this.state.sensorFromDate)
                    : dayjs()
                }
                format="MM-DD-YYYY"
                // disabledDate={(current) => {
                //   return current && current > dayjs();
                // }}
                getPopupContainer={() =>
                  document.querySelector(".sensor-graph-modal")
                }
                onChange={(date) => {
                  if (date === null) {
                    this.setState({ sensorFromDate: "" });
                  } else {
                    const format = "YYYY-MM-DD 00:00:00";
                    this.setState({ sensorFromDate: date.format(format) });
                  }
                }}
              />
              <DatePicker
                className="sensors-field"
                value={
                  this.state.sensorToDate
                    ? dayjs(this.state.sensorToDate)
                    : dayjs()
                }
                format="MM-DD-YYYY"
                disabledDate={(current) => {
                  return current && current > dayjs();
                }}
                getPopupContainer={() =>
                  document.querySelector(".sensor-graph-modal")
                }
                onChange={(date) => {
                  if (date === null) {
                    this.setState({ sensorToDate: "" });
                  } else {
                    const format = "YYYY-MM-DD 23:59:00";
                    this.setState({ sensorToDate: date.format(format) });
                  }
                }}
              />
            </div>
            <div style={{ marginBottom: "50px" }}>
              <ResponsiveContainer height={420}>
                {this.state.sensorGraphArray &&
                this.state.sensorGraphArray.length > 0 ? (
                  <LineChart
                    width={500}
                    data={this.state.sensorGraphArray}
                    margin={{ top: 20, right: 30, left: 20, bottom: 50 }}
                  >
                    <XAxis
                      dataKey="timestamp"
                      type="category"
                      angle={-90}
                      textAnchor="end"
                      label={{ value: "Time", position: "bottom", offset: 50 }}
                      height={120}
                    />
                    <YAxis
                      label={{
                        value: "Temperature /Humidity",
                        angle: -90,
                        position: "insideLeft",
                        offset: 0,
                        dy: 10, // pushes the label downward toward center
                        style: { textAnchor: "middle" },
                      }}
                    />
                    <Tooltip />
                    <Legend verticalAlign="top" />
                    <Line
                      type="monotone"
                      dataKey="temperature"
                      stroke="blue"
                      name="Temperature (°C)"
                      dot={true}
                    />
                    <Line
                      type="monotone"
                      dataKey="humidity"
                      stroke="green"
                      name="Humidity (%)"
                      dot={true}
                    />
                  </LineChart>
                ) : (
                  <Empty></Empty>
                )}
              </ResponsiveContainer>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}
GatewayDashboard.contextType = StoreContext;
export default observer(withRouter(GatewayDashboard));
